(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-long-description"]) return;
  try {
    
  const descriptionContainer = document.querySelector('.collection-long-description-container');
  const description = document.querySelector('.collection-long-description');
  const descriptionBtn = document.querySelector('.collection-long-description-btn');

  descriptionBtn?.addEventListener('click', () => {
    descriptionContainer.classList.toggle('description-open');
    description.classList.toggle('collection-long-description-show');
    descriptionBtn.classList.toggle('less');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-sticky-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-sticky-banner')) {
    class ScrollStickyBanner extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;

        this._initialized = true;
        this.card = this.querySelector('[data-banner-card]');
        this.dock = this.querySelector('[data-banner-dock]');
        this.delayMilliseconds = Math.max(0, Number(this.dataset.delaySeconds || 0) * 1000);
        this.scrollTrigger = Math.max(0, Number(this.dataset.scrollTrigger || 0));
        this.bottomOffset = Math.max(0, Number(this.dataset.bottomOffset || 0));
        this.revealed = false;
        this.delayStarted = false;
        this.canDock = false;
        this.dockStart = Number.POSITIVE_INFINITY;
        this.lastScrollY = this.getScrollY();

        if (!this.card || !this.dock) return;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
          this.resizeObserver.observe(this.card);
        }

        if (window.Shopify && window.Shopify.designMode) {
          this.classList.add('is-editor-visible', 'is-docked');
          this.measure();
          return;
        }

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('pageshow', this.handleResize);

        requestAnimationFrame(() => {
          this.measure();
          this.evaluate();
        });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('pageshow', this.handleResize);
        this.resizeObserver?.disconnect();
        window.clearTimeout(this.delayTimer);
        window.cancelAnimationFrame(this.scrollFrame);
        window.cancelAnimationFrame(this.resizeFrame);
        this._initialized = false;
      }

      getScrollY() {
        return window.scrollY ?? window.pageYOffset ?? document.documentElement.scrollTop ?? 0;
      }

      handleScroll() {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.evaluate();
        });
      }

      handleResize() {
        this.scheduleMeasure();
      }

      scheduleMeasure() {
        window.cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = window.requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.measure();
        });
      }

      isPastTrigger(scrollY = this.getScrollY()) {
        return scrollY > this.scrollTrigger;
      }

      resetBanner() {
        window.clearTimeout(this.delayTimer);
        this.delayTimer = null;
        this.delayStarted = false;
        this.revealed = false;
        this.canDock = false;
        this.classList.remove('is-revealed', 'is-floating', 'is-docked');
      }

      startDelay() {
        if (this.delayStarted || this.revealed) return;

        this.delayStarted = true;

        if (this.delayMilliseconds === 0) {
          this.reveal();
          return;
        }

        this.delayTimer = window.setTimeout(() => {
          this.delayTimer = null;

          if (!this.isPastTrigger()) {
            this.resetBanner();
            return;
          }

          this.reveal();
        }, this.delayMilliseconds);
      }

      reveal() {
        if (this.revealed) return;

        const currentScrollY = this.getScrollY();

        if (!this.isPastTrigger(currentScrollY)) {
          this.resetBanner();
          return;
        }

        this.revealed = true;
        this.canDock = Number.isFinite(this.dockStart) && currentScrollY < this.dockStart;
        this.classList.add('is-revealed', 'is-floating');
        this.classList.remove('is-docked');
        this.lastScrollY = currentScrollY;

        requestAnimationFrame(() => this.evaluate());
      }

      measure() {
        if (!this.card || !this.dock) return;

        const cardHeight = this.card.offsetHeight;
        this.style.setProperty('--ssb-height', `${cardHeight}px`);

        const currentScrollY = this.getScrollY();
        const dockTop = this.dock.getBoundingClientRect().top + currentScrollY;
        this.dockStart = Math.max(
          0,
          dockTop - window.innerHeight + cardHeight + this.bottomOffset
        );

        if (currentScrollY < this.dockStart) {
          this.canDock = true;
        }

        this.evaluate();
      }

      evaluate() {
        const currentScrollY = this.getScrollY();

        /*
         * Al volver al punto de activación o por encima de él, ocultamos el
         * banner y reiniciamos el retraso. La próxima bajada inicia un ciclo
         * nuevo con la misma configuración de scroll y tiempo.
         */
        if (!this.isPastTrigger(currentScrollY)) {
          if (this.revealed || this.delayStarted) {
            this.resetBanner();
          }

          this.lastScrollY = currentScrollY;
          return;
        }

        if (!this.revealed) {
          this.startDelay();
          this.lastScrollY = currentScrollY;
          return;
        }

        /*
         * Si el retraso termina después de haber cruzado el punto de acople,
         * primero mostramos el banner flotante. El acople se habilita de nuevo
         * cuando el usuario vuelve a estar por encima de la posición final.
         */
        if (currentScrollY < this.dockStart) {
          this.canDock = true;
        }

        const shouldDock = this.canDock && currentScrollY >= this.dockStart;
        this.classList.toggle('is-docked', shouldDock);
        this.classList.toggle('is-floating', !shouldDock);
        this.lastScrollY = currentScrollY;
      }
    }

    customElements.define('scroll-sticky-banner', ScrollStickyBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
